import { alpha } from '@mui/system';
export var TableRowTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {},
    variants: [
        {
            props: { hover: true },
            style: {
                '&&:hover': {
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.24),
                },
            },
        },
        {
            props: { selected: true },
            style: {
                '&&': {
                    backgroundColor: alpha(theme.palette.greySecondary.A100, 0.36),
                    '&&:hover': {
                        backgroundColor: alpha(theme.palette.greySecondary.A100, 0.48),
                    },
                },
            },
        },
    ],
}); };
export default TableRowTheme;
//# sourceMappingURL=theme.js.map